// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__23Rf-","title":"card_title__Fg_M-","inActive":"card_inActive__3I3L-"};